// extracted by mini-css-extract-plugin
export var dataCell = "_rl-2";
export var dataRow = "_rl-0";
export var headerRow = "_rl-1";